export enum RANGE_PICKER {
  CONTAINER = "rangePickerContainer",
  NAV_PREV = "rangePickerNavPrev",
  NAV_NEXT = "rangePickerNavNext",
}
